import { createFileRoute, useLocation } from '@tanstack/react-router'
import { z } from 'zod'
import { CustomerForm, customerSearchSchema } from '@/features/master-data/index.ts'

export const Route = createFileRoute('/_authenticated/customer-management/customers/$customerId/edit')({
  component: CustomerFormPage,
  head: () => ({ meta: [{ title: '编辑客户 · Super Mega' }] }),
  validateSearch: z.object({})
})

function CustomerFormPage() {
  const savedReturnSearch = useLocation({ select: (location) => location.state.customerListReturnSearch })
  const returnSearch = customerSearchSchema.parse(savedReturnSearch ?? {})
  const { customerId } = Route.useParams()
  return <CustomerForm key={customerId} customerId={Number(customerId)} returnSearch={returnSearch} />
}
